"use client";

import React, { ComponentType, SVGProps } from "react";

type InfoBoxProps = {
  value?: string | null;
  Icon: ComponentType<SVGProps<SVGSVGElement>> | null;
};

export const InfoBox: React.FC<InfoBoxProps> = ({ value, Icon }) => {
  if (!value) return null;

  return (
    <div className="flex items-center gap-x-2 text-foreground text-sm">
      {Icon && <Icon className="size-4 text-foreground flex-shrink-0" />}
      <span>{value}</span>
    </div>
  );
};
